import React from "react";
import {withNamespaces} from "react-i18next";
import HilightTable from "../../../../components/HilightTable";
import Moment from "react-moment";
import {Button, ButtonGroup, Spinner} from "react-bootstrap";
import {modalActions} from "../../../../actions/modal.actions";
import {connect} from "react-redux";
import DeviceGroupScheduleExceptionForm from "../_forms/DeviceGroupScheduleExceptionForm";
import * as moment from "moment";
import {deviceGroupScheduleAction} from "../../../../actions/device-group-schedule.actions";
import {claimTypes} from "../../../../constants/claim.constants";

const DeviceGroupScheduleExceptionTable = ({list, t, user, showModal, hideModal, editScheduleException, deleteScheduleException}) => {

    const scheduleCrudPermission = user[`c_schedule.actions.crud`] || null;

    const openEditScheduleExceptionModal = (row) => {
        const modalProps = {
            open: true,
            title: t('edit-schedule-exception'),
            component: <DeviceGroupScheduleExceptionForm data={row} submit={handleSubmitEdit} />,
            submitBtn: {
                className: 'btn btn-primary',
                label: 'save-changes'
            }
        };
        showModal(modalProps, 'formModal');
    };

    const openDeleteScheduleExceptionModal = (row) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('delete-msg') + `<h5> ${moment(row.date).format('YYYY/MM/DD')} </h5>`,
            confirmLabel: t('delete-btn'),
            confirmIcon: 'fa-trash',
            classNameBtnConfirm: 'btn-danger',
            dataId: row.id,
            confirmAction: (id) => {
                deleteScheduleException(row);
                hideModal();
            },
            closeModal: closeModal,
        }, 'confirm')
    };

    const closeModal = () => {
        hideModal();
    };

    const handleSubmitEdit = (data, errorValidation) => {
        editScheduleException(data, (error) => {
            errorValidation(error);
        });
    };

    const columns = [
        {
            Header: 'date',
            Cell: (props) => {
                const data = props.row.original;
                return <Moment format="YYYY/MM/DD">{data.date}</Moment>
            }
        },
        {
            Header: 'start-time',
            accessor: 'startTime'
        },
        {
            Header: 'end-time',
            accessor: 'endTime'
        },
        {
            Header: 'type',
            Cell: (props) => {
                const data = props.row.original;
                return (
                    t(data.type.toLowerCase())
                )
            }
        },
        {
            Header: 'actions',
            headerClassName: "text-right",
            classNameRow: 'text-right',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            show: scheduleCrudPermission === claimTypes.READ_WRITE,
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <ButtonGroup size={'sm'}>
                        <Button variant={"primary"} onClick={() => openEditScheduleExceptionModal(data)}>
                            <i className="fas fa-edit" />
                        </Button>
                        &nbsp;
                        <Button variant={"danger"} onClick={() => openDeleteScheduleExceptionModal(data)}>
                            <i className="fas fa-trash" />
                        </Button>
                    </ButtonGroup>
                )
            }
        }
    ];

    const tableResult = (
        list ?
            list.length === 0 ? (
                <div className="text-center p-4">
                    <h3>{t('schedule-exception-no-content')}</h3>
                </div>
            ) : (
                <HilightTable
                    columns={columns}
                    data={list}
                />
            ) : (
                <React.Fragment>
                    <Spinner animation={"border"} />
                    <p>Loading ...</p>
                </React.Fragment>

            )
    );

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            {tableResult}
        </div>
    )
};

const mapStateToProps = (state) => {
    const { user } = state.authenticationReducer;
    return {
        user
    }
};

const mapDispatchToProps = dispatch => ({
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({ modalProps, modalType }))
    },
    editScheduleException: (scheduleExceptionModel, errorValidation) => {
        dispatch(deviceGroupScheduleAction.editScheduleException(scheduleExceptionModel, errorValidation));
    },
    deleteScheduleException: (scheduleExceptionModel) => {
        dispatch(deviceGroupScheduleAction.deleteScheduleException(scheduleExceptionModel));
    }
});

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(DeviceGroupScheduleExceptionTable));
